import styled from 'styled-components';

export const LoyaltyLogo = styled.img`
  display: block;
  margin: 1em auto;
  width: 100px;
  height: auto;
`;
